import React from 'react';
import PropTypes from 'prop-types';

export default function SortButton({ field, label, currentField, direction, onClick }) {
  const isActive = field === currentField;

  return (
    <button
      className={`sort-button ${isActive ? 'active' : ''} ${isActive ? direction : ''}`}
      onClick={() => onClick(field)}
      title={label}
    >
      <span className="button-content">
        <span className="icon"></span>
        <span className="label">{label.replace('Sort by ', '')}</span>
        {isActive && (
          <span className="sort-arrow">{direction === 'asc' ? '↑' : '↓'}</span>
        )}
      </span>
      <style jsx>{`
        .sort-button {
          background: var(--surface-light);
          border: 1px solid rgba(255, 255, 255, 0.1);
          border-radius: 4px;
          color: var(--text);
          padding: 0 12px;
          font-size: 13px;
          cursor: pointer;
          transition: all 0.2s ease;
          width: auto;
          min-width: 110px;
          height: 32px;
          display: inline-flex;
          align-items: center;
          justify-content: center;
          margin: 0;
          flex-shrink: 0;
        }

        .button-content {
          display: flex;
          align-items: center;
          justify-content: center;
          gap: 6px;
          width: 100%;
        }

        .icon {
          width: 16px;
          height: 16px;
          background-size: contain;
          background-repeat: no-repeat;
          background-position: center;
          opacity: 0.7;
          transition: opacity 0.2s ease;
        }

        .sort-button:hover .icon {
          opacity: 1;
        }

        .sort-button.active .icon {
          opacity: 1;
        }

        /* Icon for Bet/Weight */
        .sort-button[title*="Bet"] .icon,
        .sort-button[title*="Weight"] .icon {
          background-image: url('data:image/svg+xml,<svg xmlns="http://www.w3.org/2000/svg" fill="white" viewBox="0 0 24 24"><path d="M11.8 10.9c-2.27-.59-3-1.2-3-2.15 0-1.09 1.01-1.85 2.7-1.85 1.78 0 2.44.85 2.5 2.1h2.21c-.07-1.72-1.12-3.3-3.21-3.81V3h-3v2.16c-1.94.42-3.5 1.68-3.5 3.61 0 2.31 1.91 3.46 4.7 4.13 2.5.6 3 1.48 3 2.41 0 .69-.49 1.79-2.7 1.79-2.06 0-2.87-.92-2.98-2.1h-2.2c.12 2.19 1.76 3.42 3.68 3.83V21h3v-2.15c1.95-.37 3.5-1.5 3.5-3.55 0-2.84-2.43-3.81-4.7-4.4z"/></svg>');
        }

        /* Icon for Odds */
        .sort-button[title*="Odds"] .icon {
          background-image: url('data:image/svg+xml,<svg xmlns="http://www.w3.org/2000/svg" fill="white" viewBox="0 0 24 24"><path d="M9 4H7v2H5v12h2v2h2v-2h2V6H9V4zm0 12H7V8h2v8zm10-8h-2V4h-2v4h-2v7h2v5h2v-5h2V8zm-2 5h-2v-3h2v3z"/></svg>');
        }

        /* Icon for Win */
        .sort-button[title*="Win"] .icon {
          background-image: url('data:image/svg+xml,<svg xmlns="http://www.w3.org/2000/svg" fill="none" stroke="white" stroke-width="2" viewBox="0 0 24 24"><path d="M3 3v18h18 M9 17v-8 M13 17V7 M17 17v-4"/></svg>');
        }

        /* Icon for Support/Strategies */
        .sort-button[title*="Support"] .icon {
          background-image: url('data:image/svg+xml,<svg xmlns="http://www.w3.org/2000/svg" fill="white" viewBox="0 0 24 24"><path d="M14 10H2v2h12v-2zm0-4H2v2h12V6zm4 8v-4h-2v4h-4v2h4v4h2v-4h4v-2h-4zM2 16h8v-2H2v2z"/></svg>');
        }

        .label {
          display: block;
          text-align: center;
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
        }

        .sort-button:hover {
          background: var(--surface-hover);
        }

        .sort-button.active {
          background: var(--primary);
          border-color: var(--primary);
        }

        .sort-arrow {
          display: inline-flex;
          align-items: center;
          justify-content: center;
          width: 12px;
          flex-shrink: 0;
        }

        @media (max-width: 768px) {
          .sort-button {
            width: 100%;
            min-width: 0;
            padding: 0 8px;
            font-size: 12px;
            height: 28px;
            margin: 0;
          }

          .button-content {
            gap: 4px;
          }

          .sort-arrow {
            width: 10px;
          }
        }
      `}</style>
    </button>
  );
}

SortButton.propTypes = {
  field: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
  currentField: PropTypes.string.isRequired,
  direction: PropTypes.oneOf(['asc', 'desc']).isRequired,
  onClick: PropTypes.func.isRequired
}; 